<template>
  <div className="component-footer">
    <div>
      <!-- Copyright @ 2009-{{
        new Date().getFullYear()
      }} -->
      北京花世管理咨询有限公司 
      <!-- All Rights Reserved -->
      <!-- <a style="color: #fff" href="https://beian.miit.gov.cn">
        京ICP备19048049号-8
      </a> -->
    </div>
    <div>公司地址：北京市朝阳区西大望路3号院3号楼25层2909</div>
    <div>
      电话：18611247868 ｜
      <a
        style="color: #fffdfd"
        href="https://qnunion.feierlaiedu.com/kcschool/hIT6Jkias6T5Qd0fXXvFt3aQSDypQOmD"
        >用户隐私协议</a
      >
      ｜
      <a
        style="color: #fffdfd"
        href="http://qnunion.feierlaiedu.com/kcschool/tBdibc2GZDUc7ee3Zko5w92odBqMygKO"
        >用户服务协议</a
      >
    </div>
  </div>
</template>
<script setup></script>
<style lang="scss" scoped>
.component-footer {
  width: 100%;
  background-color: #142E4E;
  padding: 30px 0 50px;
  box-sizing: border-box;
  font-size: 12px;
  color: #fffdfd;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  line-height: 30px;
  div {
    opacity: 0.7;
  }
}
</style>
